import { colors, fonts, space, sizes } from '../../../../theme/tokens'

export const styles = theme => ({
  bar: {
    position: 'sticky',
    top: 0,
    zIndex: 100,
    background: colors.paper,
    borderBottom: `1px solid ${colors.line}`
  },
  inner: {
    maxWidth: sizes.containerPage,
    margin: '0 auto',
    padding: `${space(12)}px ${space(20)}px`,
    display: 'flex',
    alignItems: 'center',
    gap: space(20),
    '@media (min-width: 960px)': {
      padding: `${space(12)}px ${space(24)}px`,
      gap: space(32)
    }
  },
  // 44 high so the only link out of the booking screen is a legal tap target
  // (DESIGN.md §3). The header pays the same with min-height on
  // .gwmc-header-brand.
  logoLink: {
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
    minHeight: sizes.tapMin
  },
  // The drawn height, and the only size that matters: 24px, as --mark-h gives
  // the header and the footer. `width: auto` keeps the aspect from the
  // attributes (MARK in index.js). It was 32 here, 36 from 600px up, which is
  // why the mark read as too big beside the same mark on the home page.
  logoImg: {
    display: 'block',
    height: space(24),
    width: 'auto'
  },
  // Desktop stepper
  steps: {
    display: 'none',
    '@media (min-width: 720px)': {
      display: 'flex',
      alignItems: 'center',
      flex: 1,
      justifyContent: 'flex-end',
      gap: 0
    }
  },
  stepGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 10
  },
  stepDot: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: fonts.body,
    fontSize: 13,
    fontWeight: 600,
    border: `1px solid ${colors.line}`,
    background: colors.paper,
    color: colors.mute,
    transition: 'all 0.15s ease'
  },
  stepDotCurrent: {
    borderColor: colors.accent,
    background: colors.accentSoft,
    color: colors.accent
  },
  stepDotDone: {
    background: colors.accent,
    borderColor: colors.accent,
    color: colors.onAccent
  },
  stepLabel: {
    fontFamily: fonts.body,
    fontSize: 14,
    fontWeight: 500,
    color: colors.mute,
    transition: 'color 0.15s ease, font-weight 0.15s ease'
  },
  stepLabelCurrent: {
    color: colors.ink,
    fontWeight: 600
  },
  stepLabelDone: {
    color: colors.mute
  },
  connector: {
    width: 36,
    height: 2,
    background: colors.line,
    margin: `0 ${space(8)}px`,
    borderRadius: 1,
    transition: 'background 0.15s ease'
  },
  connectorDone: {
    background: colors.accent
  },
  // Mobile
  mobile: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: 6,
    '@media (min-width: 720px)': {
      display: 'none'
    }
  },
  mobileLine: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between'
  },
  mobileStep: {
    fontFamily: fonts.body,
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: colors.mute
  },
  mobileTitle: {
    fontFamily: fonts.body,
    fontSize: 14,
    fontWeight: 600,
    color: colors.ink
  },
  mobileBar: {
    height: space(4),
    background: colors.line,
    borderRadius: 2,
    overflow: 'hidden'
  },
  mobileBarFill: {
    height: '100%',
    background: colors.accent,
    borderRadius: 2,
    transition: 'width 0.25s ease'
  }
})
